import {documentTypes} from '../../../util/uiconstants';

const validDocumentTypes = [documentTypes.evidence, documentTypes.crash];

export default (documents) => {
	const count = documents?.filter((document) => validDocumentTypes.includes(document.documentTypeId))?.length || 0;
	return count === 0 ? '-' : count;
};
